import { ListSupplies } from "~/components/admin/operations";
import PageMeta from "~/components/common/meta";

export const ScreenSupplies = () => {
  return (
    <>
      <PageMeta title="Supplies | Art Handler" description="Supplies" />
      <ListSupplies />
    </>
  );
};
